<div :class="getRowStyle(source.index)" :style="getStyle()">
  <!-- リストのみの表示の場合 -->
  <template v-if="currentTab === 0">
    <div class="item-check checkbox-size-lg">
      <b-form-checkbox
        v-model="splitCheckValue"
        @change="handleChange(GRAPH_CHECK_COLUMN.SPLIT, splitCheckValue, source.line)"
        :disabled="source.value===null"
      />
    </div>
    <div class="item-check checkbox-size-lg">
      <b-form-checkbox
        v-model="unionCheckValue"
        @change="handleChange(GRAPH_CHECK_COLUMN.UNION, unionCheckValue, source.line)"
        :disabled="source.value===null"
      />
    </div>
    <div class="item-system" v-show="isSystemRow">{{ source.system }}</div>
    <div class="item-name">{{ source.name }}</div>
    <div class="item-value">{{ source.value }}</div>
    <div class="item-unit">{{ source.unit }}</div>
    <div class="item-value">{{ source.max }}</div>
    <div class="item-value">{{ source.min }}</div>
    <div class="item-value">{{ source.avg }}</div>
  </template>

  <!-- グラフとリストの横並び表示の場合 -->
  <template v-else>
    <div class="item-check checkbox-size-lg">
      <b-form-checkbox
        v-model="splitCheckValue"
        @change="handleChange(GRAPH_CHECK_COLUMN.SPLIT, splitCheckValue, source.line)"
        :disabled="source.value===null"
      />
    </div>
    <div class="item-check checkbox-size-lg">
      <b-form-checkbox
        v-model="unionCheckValue"
        @change="handleChange(GRAPH_CHECK_COLUMN.UNION, unionCheckValue, source.line)"
        :disabled="source.value===null"
      />
    </div>
    <div
      class="item-system"
      @mouseover="handleMouseOver"
      @click="onClickRow(source.line)"
      v-show="isSystemRow"
      v-bind:data-fulltext="source.system"
      v-bind:data-top="scrollOffset"
    >
      {{ source.system }}
    </div>
    <div
      class="item-name"
      @mouseover="handleMouseOver"
      @click="onClickRow(source.line)"
      v-bind:data-fulltext="source.name"
      v-bind:data-top="scrollOffset"
      v-bind:data-left-delta="tooltipLeftDelta"
    >
      {{ source.name }}
    </div>
    <div
      class="item-value"
      @mouseover="handleMouseOver"
      @click="onClickRow(source.line)"
      v-bind:data-fulltext="source.value"
      v-bind:data-top="scrollOffset"
      v-bind:data-left-delta="tooltipLeftDelta"
    >
      {{ source.value }}
    </div>
    <div
      class="item-unit"
      @mouseover="handleMouseOver"
      @click="onClickRow(source.line)"
      v-bind:data-fulltext="source.unit"
      v-bind:data-top="scrollOffset"
      v-bind:data-left-delta="tooltipLeftDelta"
    >
      {{ source.unit }}
    </div>
  </template>
</div>
